import axios from 'axios';

interface User {
  id: string;
  email: string;
  name?: string;
  picture?: string;
  subscription_tier?: string;
  remaining_images?: number;
  remaining_follow_ups?: number;
}

interface GoogleAuthResponse {
  user: User;
  isNewUser: boolean;
}

// Configure axios with proper CORS settings
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const verifyGoogleToken = async (token: string): Promise<{ user: User }> => {
  try {
    console.log('Sending token to backend API:', import.meta.env.VITE_API_URL);
    
    // Send the token to our backend API for verification
    const response = await api.post<GoogleAuthResponse>(
      '/auth/google',
      { token }
    );
    
    console.log('Backend response:', response.data);
    
    return {
      user: response.data.user
    };
  } catch (error) {
    console.error('Error verifying Google token:', error);
    
    if (axios.isAxiosError(error)) {
      console.error('API Error:', error.response?.data || error.message);
    }
    
    throw new Error('Failed to verify Google authentication');
  }
};

export const getUserProfile = async (userId: string): Promise<User> => {
  try {
    console.log(`Fetching user profile for ID: ${userId}`);
    const response = await api.get(`/user/${userId}`);
    console.log('Profile response:', response.data);
    return response.data.user;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    
    if (axios.isAxiosError(error)) {
      console.error('API Error:', error.response?.data || error.message);
    }
    
    throw new Error('Failed to fetch user profile');
  }
};

// In the future, we'll add functions to interact with our backend API
export const registerUser = async (userData: any) => {
  try {
    // This would send user data to our backend to register the user
    const response = await axios.post(`${import.meta.env.VITE_API_URL}/auth/register`, userData);
    return response.data;
  } catch (error) {
    console.error('Error registering user:', error);
    throw error;
  }
};

export const loginUser = async (credentials: any) => {
  try {
    // This would verify credentials with our backend
    const response = await axios.post(`${import.meta.env.VITE_API_URL}/auth/login`, credentials);
    return response.data;
  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
}; 